var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSysCar = function SvgSysCar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor",
    clipPath: "url(#sysCar_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 2a10 10 0 1 0 10 10A10.011 10.011 0 0 0 12 2Zm0-2a12 12 0 1 1 0 24 12 12 0 0 1 0-24Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.5 17.016a.515.515 0 0 1-.517-.516v-.484H9.014v.484a.516.516 0 0 1-.516.516h-2a.515.515 0 0 1-.516-.516v-6c0-.102.03-.201.086-.286L8.06 7.228c.167-.279.46-.32 1.543-.365a62.11 62.11 0 0 1 2.395-.041c.906 0 1.757.014 2.395.041 1.084.045 1.377.086 1.543.365l1.991 2.986a.518.518 0 0 1 .086.286v6a.516.516 0 0 1-.516.516H15.5Zm1.483-2.031v-2.968H7.015v2.968h9.968Zm0-4v-.328l-1.806-2.71a54.653 54.653 0 0 0-6.356 0l-1.806 2.71v.328h9.968ZM13.498 14v-1h2v1h-2Zm-5 0v-1h2v1h-2Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "sysCar_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
};
export default SvgSysCar;